/* custom-tangiblee-bridge.js — Tangiblee virtual try-on on the Horizon PDP.
   Loaded by layout/theme.liquid on product pages instead of the bare
   Tangiblee script tag the Impulse theme used.

   Tangiblee's "managed" bundle was configured against the old Impulse
   markup and looks for these selectors (none of which Horizon renders):

     .product__main-photos .product-main-slide   where the Try It On button goes
     [data-product-price]                         the price it shows in the widget
     .add-to-cart.textboxAddToCartBtn             the button its own Add to cart clicks
     ShopifyAnalytics.meta.product / ?variant=    the SKU (Horizon provides these)

   Rather than ask Tangiblee to re-map their config, this script tags the
   equivalent Horizon elements with those class names before loading the
   bundle, then re-tags after Horizon re-renders the section (variant
   changes) or the viewport crosses the mobile breakpoint, because Horizon
   renders a grid gallery on desktop and a slideshow on mobile and the
   button must sit in whichever is visible. Removing this file and the
   theme.liquid hook removes the integration entirely. */
(function () {
  var BUNDLE =
    'https://cdn.tangiblee.com/integration/5.0/managed/www.hamiltonjewelers.com/revision_2/variation_original/tangiblee-bundle.min.js';
  var desktop = window.matchMedia('(min-width: 750px)');
  var timer;

  function gallery() {
    return document.querySelector('.product-information__media');
  }

  /* The first visible media slot: grid cell on desktop, slideshow slide on mobile. */
  function firstSlide() {
    var g = gallery();
    if (!g) return null;
    return desktop.matches
      ? g.querySelector('.media-gallery__grid .product-media-container')
      : g.querySelector('slideshow-slides .product-media-container');
  }

  function tag() {
    var g = gallery();
    if (!g) return null;
    g.classList.add('product__main-photos');
    g.querySelectorAll('.product-main-slide').forEach(function (el) {
      el.classList.remove('product-main-slide');
    });
    var slide = firstSlide();
    if (slide) slide.classList.add('product-main-slide');

    var price = document.querySelector('.product-information product-price .price');
    if (price) price.setAttribute('data-product-price', '');

    document.querySelectorAll('.product-information .add-to-cart-button').forEach(function (btn) {
      btn.classList.add('add-to-cart', 'textboxAddToCartBtn');
    });
    return slide;
  }

  /* After a re-render, point the bundle's CTA at the current slot and let it
     draw the button again (its own reinjectCTA keys off Impulse selectors). */
  function reinject() {
    var cfg = window.globalTangiblee && window.globalTangiblee.frameConfigs && window.globalTangiblee.frameConfigs.default;
    var slide = tag();
    if (!cfg || !cfg.cta || !slide) return;
    if (cfg.cta._container === slide && slide.querySelector('.tangiblee-cta')) return;
    document.querySelectorAll('.tangiblee-cta').forEach(function (el) {
      el.remove();
    });
    cfg.cta._container = slide;
    cfg.cta._button = null;
    if (typeof cfg._toggleCTA === 'function') cfg._toggleCTA();
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(reinject, 300);
  }

  function init() {
    if (!tag()) return; // not a product page layout we recognise
    var script = document.createElement('script');
    script.async = true;
    script.src = BUNDLE;
    document.body.appendChild(script);

    desktop.addEventListener('change', schedule);
    var section = document.querySelector('.product-information');
    if (section) {
      new MutationObserver(schedule).observe(section, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
